import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL + "/auth";
// change to your backend URL

export const googleLogin = async (googleToken) => {
  return axios.post(`${API_BASE}/google`, { token: googleToken });
};

export const verifyJwt = async (jwt) => {
  return axios.post(
    `${API_BASE}/verify`,
    {},
    {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    }
  );
};
